import { TNKC_TOKEN, POS_CODE } from '../service/constants.service'
import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '../views/Login'
import Main from '../components/app-layout/Main'

import Dashboard from '../views/Dashboard'
import Dashboard1 from '../components/dashboard/Dashboard1'

import Crews from '../views/Crews'
import CrewList from '../components/crew/CrewList'
import CrewProfile from '../components/crew/CrewProfile'

import Guest from '../views/Guest'
import GuestList from '../components/guest/GuestList'
import GuestProfile from '../components/guest/GuestProfile'
import GuestBooking from '../views/GuestBooking'
import GuestBookingList from '../components/guest-booking/GuestBookingList'

import CrewReservations from '../views/CrewReservations'
import CrewRsrvList from '../components/crew-reservation/CrewRsrvList'
import CrewRsrvDetails from '../components/crew-reservation/CrewRsrvDetails'
import CrewRsrvForm from '../components/crew/CrewRsrvForm'

import CrewBookings from '../views/CrewBookings'
import CrewBkngDetails from '../components/crew-booking/CrewBkngDetails'

import Calendar from '../components/calendar/Calendar'
import Timeline from '../components/calendar/Timeline'

import CrewEndorsement from '@/views/CrewEndorsement'
import CrewEndorse from '@/components/crew_endorsement/CrewEndorse'
import CrewEndorseList from '@/components/crew_endorsement/CrewEndorseList'
import BookingList from '@/components/crew-booking/BookingList.vue'
import ActiveHotels from '@/views/ActiveHotels'

import Settings from '../views/Settings'
import Hotels from '../components/set-up/_hotels/Hotels'
import Floors from '../components/set-up/_hotels/Floors'
import Rooms from '../components/set-up/_hotels/Rooms'
import Beds from '../components/set-up/_hotels/Beds'

import HotelDtls from '../components/set-up/_hotels/_sub/Hotel'
import Floor from '@/components/floors/Floor'
// import Dashboard2 from '@/components/dashboard/Dashboard2';
import Reports from '@/views/Reports'
import ActualUtilization from '@/components/reports/ActualUtilization'
import CrewStatement from '@/components/reports/CrewStatement'

import EncoderView from '../components/set-up/CustomEncoder'

import MailingResource from '@/components/set-up/MailingResource'

import Account from '@/components/account/Account'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },

  {
    path: '/main',
    name: 'Main',
    component: Main,
    redirect: '/main/dashboard/',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'endorse',
        name: 'CrewEndorsement',
        component: CrewEndorsement,
        redirect: 'endorse/operation',
        props: true,
        children: [
          { path: 'operation', name: 'CrewEndorse', component: CrewEndorse },
          { path: 'list', name: 'CrewEndorseList', component: CrewEndorseList }
        ]
      },

      {
        path: 'crew',
        name: 'Crew',
        component: Crews,
        redirect: 'crew/list',
        props: true,
        children: [
          { path: 'list', name: 'CrewList', component: CrewList },
          {
            path: ':id',
            name: 'CrewProfile',
            component: CrewProfile,
            props: true
          },
          {
            path: ':id/form',
            name: 'CrewRsrvForm',
            component: CrewRsrvForm,
            props: true
          }
        ]
      },

      {
        path: 'guest',
        name: 'Guest',
        component: Guest,
        redirect: 'guest/list',
        props: true,
        children:
            [
              {
                path: 'list',
                name: 'GuestList',
                component: GuestList,
                props: true
              },

              {
                path: ':guest_id',
                name: 'GuestProfile',
                component: GuestProfile,
                props: true
              }
            ]
      },

      {
        path: 'rsv',
        name: 'Reservation',
        component: CrewReservations,
        redirect: 'rsv/list',
        props: true,
        children: [
          {
            path: 'list',
            name: 'CrewRsrvList',
            component: CrewRsrvList,
            props: true
          },
          {
            path: ':id',
            name: 'CrewRsrvDetails',
            component: CrewRsrvDetails,
            props: true
          }
        ]
      },

      {
        path: 'crw-bkng',
        name: 'CrewBooking',
        component: CrewBookings,
        props: true,
        redirect: 'crw-bkng/:hotelId/:code',
        children: [,
          {
            path: ':id',
            name: 'CrewBkngDetails',
            component: CrewBkngDetails,
            props: true
          },

          {
            path: ':hotelId/:code',
            name: 'BookingList',
            component: BookingList,
            props: true
          }

        ]
      },

      {
        path: 'gst-bkng',
        name: 'GuestBooking',
        component: GuestBooking,
        props: true,
        redirect: 'gst-bkng/',
        children: [
          { path: 'list', name: 'GuestBookingList', component: GuestBookingList, props: true }
        ]
      },

      {
        path: 'htl',
        name: 'ActiveHotels',
        component: ActiveHotels,
        redirect: 'htl/:hotel_id/:floor_id',
        children: [
          {
            path: ':hotel_id/:floor_id',
            name: 'Floor',
            component: Floor,
            props: true
          }
        ]
      },

      {
        path: 'setting',
        name: 'Setting',
        component: Settings,
        redirect: 'setting/hotel',
        children:
            [
              {
                path: 'hotel',
                name: 'Hotel',
                component: Hotels,
                props: true
              },
              { path: 'hotel/:id', name: 'HotelDetails', component: HotelDtls, props: true },
              { path: 'floor', name: 'Floor', component: Floors },
              { path: 'room', name: 'Room', component: Rooms },
              { path: 'bed', name: 'Bed', component: Beds },
              { path: 'encoderview', name: 'EncoderView', component: EncoderView },
              { path: 'mailingResource', name: 'MailingResource', component: MailingResource }
            ]
      },

      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        redirect: 'dashboard/1',
        meta: {
          requiresAuth: true
        },
        children: [
          {
            path: '1',
            name: 'Dashboard1',
            component: Dashboard1,
            props: true
          }
          // {
          //   path: '/2',
          //   name: 'Dashboard2',
          //   component: Dashboard2
          // }
        ]
      },

      {
        path: '/reports',
        name: 'Reports',
        component: Reports,
        meta: {
          requiresAuth: true
        },
        children: [
          {
            path: 'utilization',
            name: 'ActualUtilization',
            component: ActualUtilization
          },
          {
            path: 'statement',
            name: 'CrewStatement',
            component: CrewStatement
          }
        ]
      },

      {
        path: '/account',
        name: 'Account',
        component: Account
      }
    ]
  },

  {
    path: '/calendar',
    name: 'Calendar',
    component: Calendar,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/calendar',
    name: 'Calendar',
    component: Calendar,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/timeline',
    name: 'Timeline',
    component: Timeline,
    meta: {
      requiresAuth: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// adding meta for the authenticated routes
router.beforeEach(function (to, from, next) {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem(TNKC_TOKEN) != null) {
      next()
      return
    }
    next('/')
  } else {
    next()
  }
})

export default router
